import React from "react";

const items = [
  "Web Development",
  "AI/ML",
  "MERN Stack",
  "Data Analysis",
  "Data Science",
  "Generative AI",
];

const Slider = () => {
  return (
    <div className="w-full bg-gradient-to-r from-[#406FCC] to-[#4A3FBF] py-3 lg:py-5 overflow-hidden">
      <div className="relative">
        {/* Sliding track */}
        <div className="flex items-center gap-12 whitespace-nowrap animate-marquee">
          {[...items, ...items].map((item, index) => (
            <div key={index} className="flex items-center gap-6">
              <span className="text-white text-lg md:text-xl lg:text-2xl font-medium">
                {item}
              </span>
              {/* Divider / */}
              <span className="text-white/60 text-lg md:text-xl lg:text-2xl select-none">
                /
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;
